import React from 'react'
import { FiCalendar, FiChevronDown } from 'react-icons/fi'
import DatePicker from '../../../../components/FormBuilder/DatePicker/DatePicker'
import { Desktop } from '../../../../components/MediaQuery'
import TemplateButton from '../../../../components/Template/Button'

function CalendarPicker({
  startDate,
  changeDate,
  anchor,
  size = 1,
  className,
  minDate,
  maxDate,
}: ICalendarPickerProps & ICalendarPickerDispatch) {
  const [show, setShow] = React.useState(false)

  function toggleShow() {
    setShow(!show)
  }

  function disableShow() {
    setShow(false)
  }

  return (
    <Desktop>
      <TemplateButton
        size={size}
        ref={anchor}
        outline={true}
        onClick={toggleShow}
        className={`${className}-button-expand`}
      >
        <FiCalendar size={16 * size} />
        <FiChevronDown size={16 * size} />
      </TemplateButton>
      {show && (
        <DatePicker
          open={show}
          onClose={disableShow}
          onDateChange={changeDate()}
          initialDate={startDate}
          anchorEl={anchor.current}
          placement={'bottom'}
          styles={{ zIndex: 6000 }}
          minDate={minDate}
          maxDate={maxDate}
        />
      )}
    </Desktop>
  )
}

export default CalendarPicker

export interface ICalendarPickerProps {
  startDate: Date
  anchor?: React.RefObject<HTMLAnchorElement> | null
  className?: string
  size?: number
  minDate?: Date
  maxDate?: Date
}

export interface ICalendarPickerDispatch {
  changeDate: () => (selectedDate: Date) => void
}
